/**
 * Custom DayButton for react-day-picker. When `badgeText` is set it overlays a
 * small label on the selected day for outbound/return in round-trip mode when
 * one leg is an open ticket.
 * When `showTodayAccentHint` is true, today's cell uses accent colour + icon
 * (unless today is the outbound or return endpoint of the selected range).
 */
const DayButtonWithBadge = ({
  modifiers,
  children,
  badgeText,
  showTodayAccentHint,
  dayData,
  // eslint-disable-next-line no-unused-vars
  day,
  onDayWithPriceHover,
  className,
  ...buttonProps
}) => {
  const isTodayAccentHint =
    showTodayAccentHint && modifiers.today && !modifiers.outside;

  const isRangeEndpoint =
    modifiers.range_start ||
    modifiers.range_end ||
    (modifiers.selected && !modifiers.range_middle);
  const priceLevelIndicatorClass =
    isRangeEndpoint && dayData?.available && dayData?.priceLevel
      ? `udp-day_button--price-dot udp-day_button--price-dot-${dayData.priceLevel}`
      : '';

  const mergedClassName = [className, isTodayAccentHint ? 'udp-day_button--today-hint' : '', priceLevelIndicatorClass]
    .filter(Boolean)
    .join(' ');

  const handleMouseEnter = e => {
    buttonProps.onMouseEnter?.(e);
    if (dayData?.minPrice != null && onDayWithPriceHover) {
      onDayWithPriceHover(dayData);
    }
  };

  return (
    <button {...buttonProps} className={mergedClassName} onMouseEnter={handleMouseEnter}>
      {children}
      {modifiers.selected && badgeText && <span className="udp-day-badge">{badgeText}</span>}
    </button>
  );
};

export default DayButtonWithBadge;
